module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Subscriptions"},"es":{"title":"Suscripcións"},"fr":{"title":"Souscriptions"},"it":{"title":"Abbonamenti"},"pt":{"title":"Subscrições"},"pl":{"title":"Subskrypcje"}}')
  delete Component.options._Ctor
}
